<script>
    import TimePickerModal from "svelte-time-picker";
    import { fade } from "svelte/transition";
    import { formatDate, internationalize } from "timeUtils";

    export let id;
    export let value;
    export let current;
    export let format = "#{G}h#{i}";
    export let label;
    export let placeholder = "Choisissez une heure";
    export let icon = "fa fa-clock";
    export let required = true;
    export let reset = true;
    export let margin = true;
    export let toolbar = true;

    const cancelCallback = (e) => {
        show = false;
    };

    const changeCallback = (e) => {
        let time = e.detail;
        console.log("change", time);
    };
    const okCallback = (e) => {
        let time = e.detail;
        console.log("ok", time);

        value = time;

        show = false;
        // TODO
    };
    const closeCalback = (e) => {
        console.log("close", e);
        show = false;
    };

    $: selectedTimeFormatted = formatDate(time, format);

    let time = value || new Date();
    let show = false;
    let options = {
        buttonNow: "Maintenant",
        buttonCancel: "Annuler",
        hasButtons: true,
        hasToolbar: toolbar,
        is24h: true,
        zIndex: 200,
    };
</script>

<div class="form-group" class:in={current === id} class:filled={value} class:margin>
    <!-- label -->
    <label class="sr-only" required for={id}>{label}</label>

    <!-- icon -->
    {#if icon != null}
        <div class="icon-left">
            <i class={icon} />
        </div>
    {/if}

    <span {id} class="date" on:click={() => (show = true)}>
        {#if value}{selectedTimeFormatted}{:else}{placeholder}{/if}
    </span>

    <input
        name={id}
        type="text"
        autocomplete="off"
        class="form-control"
        bind:value
        on:focus={(e) => (current = id)}
        on:blur={() => (current = null)}
        on:click={() => (show = true)}
        {required} />

    {#if show}
        <div class="timepicker" transition:fade={{ duration: 300 }}>
            <TimePickerModal
                date={time}
                {options}
                on:cancel={cancelCallback}
                on:change={changeCallback}
                on:ok={okCallback}
                on:close={closeCalback} />
        </div>
    {/if}

    <!-- reset button -->
    {#if reset}
        <div class="icon-right reset">
            <button
                on:click={() => {
                    value = new Date();
                }}
                type="button"
                class="reset"
                tabindex="-1">
                <i class="fa fa-times-circle" />
            </button>
        </div>
    {/if}

    <!-- custom button -->
    <slot />
</div>

<style>
    span.date {
        line-height: 40px;
        position: absolute;
        z-index: 1;
        left: 40px;
    }

    .form-group {
        display: flex;
        position: relative;
        width: 100%;
        border-radius: 2px;
        background: #efefef;
        border: 0;
        border-radius: 0;
        box-shadow: none;
        color: #666;
        font-size: 14px;
        height: 40px;
        resize: none;
        vertical-align: middle;
        text-align: initial !important;
    }

    .margin.form-group {
        margin-bottom: 15px;
    }

    .readOnly.form-group {
        background: none;
    }

    .in.form-group {
        -webkit-box-shadow: 0 2px 0 var(--primary-light-color);
        box-shadow: 0 2px 0 var(--primary-light-color);
    }
    .in.form-group .icon-left {
        color: var(--primary-color);
    }
    .form-group .icon-left {
        width: 34px;
        padding-top: 10px;
        font-size: 17px;
        font-weight: 400;
        line-height: 1;
        text-align: right;
        background-color: #eee;
        border: 0;
        color: var(--primary-light-color);
    }

    .form-group .icon-right {
        background: 0;
        cursor: pointer;
        padding: 10px 8px 0 5px;
    }

    .form-group:not(.filled) div.reset {
        visibility: hidden !important;
    }

    .form-group .form-control {
        position: relative;
        width: 100%;
        margin-bottom: 0;
        background: #efefef;
    }

    .form-group input {
        -webkit-appearance: none;
        border: 0;
        border-radius: 0;
        -webkit-box-shadow: none;
        box-shadow: none;
        color: #efefef;
        font-size: 14px;
        height: 40px;
        padding-left: 10px;
        padding-right: 10px;
        resize: none;
        vertical-align: middle;
        width: 100%;
    }

    .form-group button {
        display: block;
    }

    .form-group button:not(:disabled):active {
        background-color: #efefef;
    }

    .form-group button.reset {
        cursor: pointer;
        background: none;
        color: #ccc;
        font-size: 18px;
        border: 0;
        border-radius: 0;
        -webkit-box-shadow: none;
        box-shadow: none;
        margin: 0;
        padding: 0;
        text-align: left;
    }

    div.timepicker {
        transform: translate(-50%, -50%) translate(0px, 0px);
        display: block;
        position: absolute;
        top: 50%;
        left: 50%;
        transition: none;
        z-index: 2;
    }
</style>
